/*
  The UI can run in an offline "test" mode which bypasses authentication
  and uses unit-test data instead of calling real APIs. To do this, each
  API endpoint is mocked, allowing our API helper (apiUtils.js) to
  intercept the calls and return appropriate test data.

  Test mode is set with VUE_APP_OFFLINE_TESTING=true
*/

//import referenceData from '../../tests/testData/referenceData'
import application from '../../tests/testData/application'
import applications from '../../tests/testData/applicationList'

export default [
  {
    endpoint: `/application/*`,
    data: application,
    httpCode: 200
  },
  {
    endpoint: `/applications/*`,
    data: applications,
    httpCode: 200
  }
]
